import "../Bid.css";
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  title = "Confirm Action",
}) => {
  if (!isOpen) return null;
  const handleConfirm = (e) => {
    e.preventDefault(); // Prevent form submission
    onConfirm();
  };
  const handleClose = (e) => {
    e.preventDefault(); // Prevent form submission
    onClose();
  };
  return (
    <div className="bid-modal-overlay">
      <div className="bid-modal-content">
        <div className="d-flex justify-content-between align-items-center ">
        <h3 className="confirm-modal-role-bid pb-0 mb-0">{title}</h3>
        <button className="bid-user-cross"  onClick={handleClose}>X</button>

        </div>
        <p className="confirm-modal-role-bid-msg pt-3">{message}</p>
        <div className="bid-modal-buttons">
          <button className="bid-confirm-button" onClick={handleConfirm}>
            Yes
          </button>
          <button className="bid-cancel-button" onClick={handleClose}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
